
import { defineComponent } from "vue";

export default defineComponent({
  name: "global-drawers",
  components: {},
});
